module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height:100%"
  }, [_c('van-sticky', [_c('van-search', {
    attrs: {
      "placeholder": "请输入搜索关键词",
      "show-action": "",
      "shape": "round"
    },
    on: {
      "keyup": _vm.onChange,
      "search": _vm.onSearch
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('div', {
    attrs: {
      "slot": "action"
    },
    on: {
      "click": _vm.onSearch
    },
    slot: "action"
  }, [_vm._v("搜索")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "screeing-box",
    style: (_vm.screeningShow ? 'height:100%' : '')
  }, [_c('div', {
    staticClass: "screening-goods"
  }, [_c('div', {
    staticClass: "screeing-goods-top"
  }, [_c('div', {
    staticClass: "screening-1",
    on: {
      "click": function($event) {
        return _vm.onScreeningShow(1)
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.options1[_vm.options1_key]))])]), _vm._v(" "), _c('div', {
    staticClass: "screening-2",
    on: {
      "click": function($event) {
        return _vm.onScreeningShow(2)
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.options2[_vm.options2_key]))])]), _vm._v(" "), _c('div', {
    staticClass: "screening-top-right",
    on: {
      "click": _vm.onSideChange
    }
  }, [_c('div', [_vm._v("筛选")]), _vm._v(" "), _c('img', {
    staticClass: "screenging-img",
    attrs: {
      "src": "https://static.dierqudao.com/images/vfd/screening.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "screeing-items"
  }, [_vm._l((_vm.options1), function(item, index) {
    return (_vm.options1_show) ? _c('div', {
      key: index,
      class: _vm.options1_key == index ? 'options_title options_title_box' : 'options_title_box',
      on: {
        "click": function($event) {
          return _vm.onOptions1Change(index)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n          ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.options2), function(item, index) {
    return (_vm.options2_show) ? _c('div', {
      key: index,
      class: _vm.options2_key == index ? 'options_title options_title_box' : 'options_title_box',
      on: {
        "click": function($event) {
          return _vm.onOptions2Change(index)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n          ")]) : _vm._e()
  })], 2)])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.8rem"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.loadingFresh),
      callback: function($$v) {
        _vm.loadingFresh = $$v
      },
      expression: "loadingFresh"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.noMore,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loadingMore),
      callback: function($$v) {
        _vm.loadingMore = $$v
      },
      expression: "loadingMore"
    }
  }, [_c('div', [_c('GoodsItems', {
    attrs: {
      "goodsList": _vm.list
    }
  })], 1)])], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '100%',
      width: '80%'
    }),
    attrs: {
      "position": "right"
    },
    on: {
      "close": _vm.onClose
    },
    model: {
      value: (_vm.sideShow),
      callback: function($$v) {
        _vm.sideShow = $$v
      },
      expression: "sideShow"
    }
  }, [_c('div', {
    staticClass: "side-box",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "price-interval"
  }, [_c('div', {
    staticClass: "price-interval-title"
  }, [_vm._v("价格区间(元)")]), _vm._v(" "), _c('div', {
    staticClass: "price-interval-box"
  }, [_c('van-field', {
    attrs: {
      "type": "digit",
      "placeholder": "最低价",
      "input-align": "center"
    },
    on: {
      "input": _vm.onPriceRangeChange1
    },
    model: {
      value: (_vm.params.price_range[0]),
      callback: function($$v) {
        _vm.$set(_vm.params.price_range, 0, $$v)
      },
      expression: "params.price_range[0]"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("——")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "type": "digit",
      "placeholder": "最高价",
      "input-align": "center"
    },
    on: {
      "input": _vm.onPriceRangeChange2
    },
    model: {
      value: (_vm.params.price_range[1]),
      callback: function($$v) {
        _vm.$set(_vm.params.price_range, 1, $$v)
      },
      expression: "params.price_range[1]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "interval-items"
  }, _vm._l((_vm.price_interval), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.interval_index == index ? 'interval_change' : '',
      on: {
        "click": function($event) {
          return _vm.onIntervalClick(index)
        }
      }
    }, [_vm._v(_vm._s(item[0]) + "-" + _vm._s(item[1]) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "side-btn"
  }, [_c('div', {
    staticClass: "side-btn-1",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('div', {
    staticClass: "side-btn-2",
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("确定")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bed1dbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/GoodsList2.vue
// module id = 2371
// module chunks = 0